/* eslint-disable no-unused-vars */
import MainLayout from '@/components/layout/applicant/MainLayout.vue';
import RegionJson from '@/assets/json/region.json';
// import Pagination from "laravel-vue-pagination";
import axios from 'axios';
import { mapGetters } from 'vuex';
import store from '@/store';
import { ConvertNumService } from "@/assets/js/convertNumberService.js";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
const convertNumberService = new ConvertNumService();
// const convertNumberService = new ConvertNumService();

/*
import lottie from 'lottie-web';
import mapAnimationRaw from '@/assets/map2.json';
import img0 from '@/assets/images/map/img_0.png';
import img1 from '@/assets/images/map/img_1.png';
import img2 from '@/assets/images/map/img_2.png';
import img3 from '@/assets/images/map/img_3.png';

const assetsMap = {
    image_0: img0,
    image_1: img1,
    image_2: img2,
    image_3: img3,
};

const mapAnimation = {
    ...mapAnimationRaw,
    assets: mapAnimationRaw.assets.map((asset) => {
        if (assetsMap[asset.id]) {
            return {
                ...asset,
                u: '',
                p: assetsMap[asset.id],
            };
        }
        return asset;
    }),
};
*/

export default {
    name: 'homeIndex',
    components: {
        MainLayout,
        AdvancedLaravelVuePaginate
    },

    data() {
        return {
            jobList: {},
            isLoading: true,
            category: [],
            topCategories: [
                { category_id: '', category_name: 'Software' },
                { category_id: '', category_name: 'Marketing' },
                { category_id: '', category_name: 'Accounting' },
                { category_id: '', category_name: 'Sales & HR' },
                { category_id: '', category_name: 'Engineering' }
            ],
            isSearched: false,
            oldKeyword: {},
            isCategoryDropdownOpen: false,
            isJobTypeDropdownOpen: false,
            isRegionDropdownOpen: false,
            regionArr: RegionJson,
            page_status: false,
            keyword: {
                job_title: '',
                job_type: '',
                category_name: '',
                region: '',
            },
            job_count: '',
            resumeCount: '',
            displayPeopleCount: 0,
            displayJobCount: 0,
            displayCompanyCount: 0,
            animated: false,
            activeFaq: 0,
        };
    },

    computed: {
        ...mapGetters({
            isApplicantLoggedIn: 'isApplicantLoggedIn',
            applicantId: 'applicantId',
            applicantToken: 'applicantToken',
            resumeCountNo: 'resumeCountNo',
        }),

        selectedCategoryName() {
            const selected = this.category.find(cat => cat.id === this.keyword.category_name);
            return selected ? selected.category_name : '';
        },

        selectedJobTypeName() {
            const types = {
                '1': 'Full-time',
                '2': 'Part-time',
                '3': 'Internship',
                '4': 'Freelance',
                '5': 'Remote Job',
            };
            return types[this.keyword.job_type] || '';
        },

        selectedRegionName() {
            if (this.keyword.region === '' || this.keyword.region === null || this.keyword.region === undefined) {
                return '';
            }
            return this.regionArr[this.keyword.region] || '';
        },

        displayedJobs() {
            if (this.isSearched) {
                return this.jobList && this.jobList.data ? this.jobList.data : [];
            } else {
                return Array.isArray(this.jobList) ? this.jobList : [];
            }
        },

        activeFiltersList() {
            const list = [];
            if (this.keyword.job_title) {
                list.push({ type: 'job_title', label: `"${this.keyword.job_title}"` });
            }
            if (this.keyword.category_name && this.selectedCategoryName) {
                list.push({ type: 'category_name', label: `"${this.selectedCategoryName}"` });
            }
            if (this.keyword.region !== '' && this.keyword.region !== null && this.keyword.region !== undefined && this.selectedRegionName) {
                list.push({ type: 'region', label: `"${this.selectedRegionName}"` });
            }
            if (this.keyword.job_type && this.selectedJobTypeName) {
                list.push({ type: 'job_type', label: `"${this.selectedJobTypeName}"` });
            }
            return list;
        },

        jobCountDisplay() {
            if (this.isSearched) {
                const count = this.jobList && this.jobList.total ? this.jobList.total : 0;
                return convertNumberService.convertEng2Mm(count.toString());
            } else {
                const count = Array.isArray(this.jobList) ? this.jobList.length : 0;
                return convertNumberService.convertEng2Mm(count.toString());
            }
        },
    },

    methods: {
        getLatestJobs() {
            this.isLoading = true;
            axios
                .get('/applicant/job/latestlist')
                .then((response) => {
                    this.jobList = response.data;
                })
                .catch((error) => {
                    console.log('Get Jobs API Error', error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        getCategory() {
            axios
                .get('/job/category/list?has_jobs=true')
                .then((response) => {
                    this.category = response.data;
                })
                .catch((error) => {
                    console.log('Get Category API Error', error);
                });
        },

        getTopCategories() {
            axios
                .get('/category/info?page=1')
                .then((response) => {
                    this.topCategories = response.data.data.slice(0, 5);
                })
                .catch((error) => {
                    console.log('Get Top Categories API Error', error);
                });
        },

        searchByCategory(cat) {
            this.keyword.job_title = '';
            if (typeof cat === 'object' && cat !== null) {
                if (cat.category_id) {
                    this.keyword.category_name = cat.category_id;
                } else {
                    const found = this.category.find(c =>
                        c.category_name && c.category_name.toLowerCase().includes(cat.category_name.toLowerCase())
                    );
                    if (found) {
                        this.keyword.category_name = found.id;
                    } else {
                        this.keyword.job_title = cat.category_name;
                    }
                }
            } else {
                this.keyword.category_name = cat;
            }
            this.keyword.region = '';
            this.keyword.job_type = '';
            this.searchJob();
        },

        getResumeCount() {
            axios
                .get('/applicant/resume/count/' + this.applicantId)
                .then((response) => {
                    this.resumeCount = response.data.count;
                    store.commit('setResumeCount', this.resumeCount);
                })
                .catch((error) => {
                    console.log(
                        'Resume Count API error:::::>',
                        error.response.data,
                    );
                });
        },

        goResumeRegister() {
            if (!this.isApplicantLoggedIn) {
                this.$router.push({ name: 'applicantLogin' });
                return;
            }
            if (this.resumeCountNo < 3) {
                this.$router.push('/resume', () => { });
            } else {
                this.$notification.error(
                    'အလုပ်လျှောက်လွှာအများဆုံး ၃ ခုသာ ပြုလုပ်ခွင့်ပြုသည်။',
                    { timer: 3, position: 'bottomCenter' },
                );
            }
        },

        handleSearchSubmit() {
            const hasRegion = this.keyword.region !== '' && this.keyword.region !== null && this.keyword.region !== undefined;
            if (!this.keyword.job_title && !this.keyword.category_name && !hasRegion && !this.keyword.job_type) {
                this.clearSearch();
            } else {
                this.searchJob();
            }
        },

        searchJob(page = 1) {
            const hasRegion = this.keyword.region !== '' && this.keyword.region !== null && this.keyword.region !== undefined;
            if (!this.keyword.job_title && !this.keyword.category_name && !hasRegion && !this.keyword.job_type) {
                this.clearSearch();
                return;
            }
            this.isLoading = true;
            var request = {
                params: {
                    keyword: this.keyword.job_title,
                    keyword1: this.keyword.category_name,
                    keyword2: hasRegion ? this.keyword.region : '',
                    keyword3: this.keyword.job_type,
                    per_page: 30,
                },
            };
            axios
                .get('/applicant/search/jobresult?page=' + page, request)
                .then((response) => {
                    this.isSearched = true;
                    this.jobList = response.data || {};
                    this.job_count = this.jobList.total ? convertNumberService.convertEng2Mm(this.jobList.total.toString()) : convertNumberService.convertEng2Mm("0");
                    this.oldKeyword = request.params;

                    this.$nextTick(() => {
                        const jobsSection = document.querySelector('.sec-jobs');
                        if (jobsSection) {
                            jobsSection.scrollIntoView({ behavior: 'smooth' });
                        }
                    });
                })
                .catch((error) => {
                    console.log('Job Search API Error', error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        clearSearch() {
            this.keyword.job_title = '';
            this.keyword.category_name = '';
            this.keyword.region = '';
            this.keyword.job_type = '';
            this.isSearched = false;
            this.getLatestJobs();

            this.$nextTick(() => {
                const jobsSection = document.querySelector('.sec-jobs');
                if (jobsSection) {
                    jobsSection.scrollIntoView({ behavior: 'smooth' });
                }
            });
        },

        getJobType(job_type) {
            const jobTypes = {
                '1': 'Full-time',
                '2': 'Part-time',
                '3': 'Internship',
                '4': 'Freelance',
                '5': 'Remote Job'
            };
            return jobTypes[job_type] || 'သတ်မှတ်ထားခြင်းမရှိပါ';
        },

        goFB(id) {
            window.open(
                'https://www.facebook.com/sharer/sharer.php?u=https://bib-job.com/job_listing/job_detail/' +
                id +
                '&t=' +
                document.title,
                '',
                'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=500',
            );
        },

        toggleSelect(event) {
            const select = event.target;
            if (select.dataset.open === 'true') {
                select.blur();
                select.dataset.open = 'false';
            } else {
                select.dataset.open = 'true';
            }
        },

        resetSelect(event) {
            event.target.dataset.open = 'false';
        },

        blurSelect(event) {
            event.target.blur();
            event.target.dataset.open = 'false';
        },

        animateCounts() {
            if (this.animated) return;
            this.animated = true;

            const duration = 2000;
            const targets = {
                people: 100,
                jobs: 500,
                companies: 150,
            };

            const startTime = performance.now();

            const animate = (currentTime) => {
                const elapsedTime = currentTime - startTime;
                const progress = Math.min(elapsedTime / duration, 1);
                const ease = 1 - Math.pow(1 - progress, 3); // easeOutCubic

                this.displayPeopleCount = Math.floor(ease * targets.people);
                this.displayJobCount = Math.floor(ease * targets.jobs);
                this.displayCompanyCount = Math.floor(ease * targets.companies);

                if (progress < 1) {
                    requestAnimationFrame(animate);
                } else {
                    this.displayPeopleCount = targets.people;
                    this.displayJobCount = targets.jobs;
                    this.displayCompanyCount = targets.companies;
                }
            };

            requestAnimationFrame(animate);
        },

        formatNumber(value) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },

        toMmNum(value) {
            if (value === undefined || value === null) return '';
            return convertNumberService.convertEng2Mm(value.toString());
        },


        toggleFaq(index) {
            if (this.activeFaq === index) {
                this.activeFaq = null;
            } else {
                this.activeFaq = index;
            }
        },

        toggleCategoryDropdown() {
            this.isCategoryDropdownOpen = !this.isCategoryDropdownOpen;
            this.isJobTypeDropdownOpen = false;
            this.isRegionDropdownOpen = false;
        },

        selectCategory(id) {
            this.keyword.category_name = id;
            this.isCategoryDropdownOpen = false;
        },

        toggleJobTypeDropdown() {
            this.isJobTypeDropdownOpen = !this.isJobTypeDropdownOpen;
            this.isCategoryDropdownOpen = false;
            this.isRegionDropdownOpen = false;
        },

        selectJobType(id) {
            this.keyword.job_type = id;
            this.isJobTypeDropdownOpen = false;
        },

        toggleRegionDropdown() {
            this.isRegionDropdownOpen = !this.isRegionDropdownOpen;
            this.isCategoryDropdownOpen = false;
            this.isJobTypeDropdownOpen = false;
        },

        selectRegion(id) {
            this.keyword.region = id;
            this.isRegionDropdownOpen = false;
        },

        handleOutsideClick(e) {
            if (!e.target.closest('.custom-select-wrapper')) {
                this.isCategoryDropdownOpen = false;
                this.isJobTypeDropdownOpen = false;
                this.isRegionDropdownOpen = false;
            }
        },

        initStatsObserver() {
            this.$nextTick(() => {
                const statsSection = document.querySelector('.sec-stats');
                if (!statsSection) {
                    this.animateCounts();
                    return;
                }

                if ('IntersectionObserver' in window) {
                    this.statsObserver = new IntersectionObserver((entries) => {
                        entries.forEach((entry) => {
                            if (entry.isIntersecting && !this.animated) {
                                this.animateCounts();
                                if (this.statsObserver) {
                                    this.statsObserver.unobserve(entry.target);
                                }
                            }
                        });
                    }, { threshold: 0.2 });

                    this.statsObserver.observe(statsSection);
                } else {
                    this.animateCounts();
                }
            });
        },
    },

    mounted() {
        // this.getAllJobs();
        this.getLatestJobs();
        this.getCategory();
        this.getTopCategories();
        if (this.applicantId) {
            this.getResumeCount();
        }

        this.initStatsObserver();

        window.addEventListener('click', this.handleOutsideClick);

        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.text = JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
                {
                    "@type": "Question",
                    "name": "BIB Job ဆိုတာ ဘာလဲ?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "BIB Job သည် မြန်မာနိုင်ငံရှိ ထိပ်တန်းကုမ္ပဏီကြီးများ၏ နောက်ဆုံးရ အလုပ်အကိုင်များကို တစ်နေရာတည်းတွင် အခမဲ့ ရှာဖွေလျှောက်ထားနိုင်သည့် ပလက်ဖောင်း ဖြစ်ပါသည်။ မိမိ၏ စွမ်းရည်များနှင့် ကိုက်ညီမည့် အလုပ်အကိုင်များကို နေ့စဉ် အချိန်နှင့်တပြေးညီ ရှာဖွေလျှောက်ထားနိုင်ပါသည်။"
                    }
                },
                {
                    "@type": "Question",
                    "name": "အလုပ်လျှောက်လျှင် ဝန်ဆောင်ခ ပေးရပါသလား?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "လုံးဝ ပေးရန် မလိုပါ။ အလုပ်ရှာဖွေသူများအနေဖြင့် အကောင့်ဖွင့်ခြင်း၊ မိမိ၏ CV Form တင်ခြင်းနှင့် အလုပ်လျှောက်ထားခြင်း အားလုံးကို အခမဲ့ ဆောင်ရွက်နိုင်ပါသည်။"
                    }
                },
                {
                    "@type": "Question",
                    "name": "အလုပ်အကိုင်များကို ဘယ်လို လွယ်ကူစွာ လျှောက်ထားရမလဲ?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "ဖုန်းနံပါတ် သို့မဟုတ် Email ဖြင့် အကောင့်ပြုလုပ်ပြီး မိမိ၏ CV Form အချက်အလက်များကို ပြည့်စုံစွာ ဖြည့်သွင်းပါ။ ထို့နောက် မိမိစိတ်ဝင်စားသည့် အလုပ်အကိုင်ကို ရှာဖွေ၍ ချက်ချင်း လျှောက်ထားနိုင်ပါသည်။"
                    }
                },
                {
                    "@type": "Question",
                    "name": "လျှောက်ထားခဲ့သော အလုပ်အခြေအနေကို ဘယ်လိုစစ်ဆေးနိုင်မလဲ?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "မိမိအကောင့်သို့ Login ဝင်ရောက်ပြီး \"လျှောက်ထားခဲ့သော အလုပ်များ\" (Applied Jobs) ကဏ္ဍတွင် မိမိလျှောက်ထားထားသည့် အလုပ်အကိုင်များ၏ အခြေအနေကို တိုက်ရိုက် စစ်ဆေးကြည့်ရှုနိုင်ပါသည်။"
                    }
                },
                {
                    "@type": "Question",
                    "name": "အချိန်ပိုင်း၊ Freelance သို့မဟုတ် နယ်အလုပ်များကိုရော ရှာဖွေနိုင်ပါသလား?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "ရှာဖွေနိုင်ပါသည်။ Search Filter တွင် Full-time, Part-time, Internship, Freelance, Remote Job စသည့် အလုပ်ချိန်အမျိုးအစားများနှင့် တိုင်းဒေသကြီး/ပြည်နယ်အလိုက် သီးသန့် စစ်ထုတ်၍ လွယ်ကူစွာ ရှာဖွေနိုင်ပါသည်။"
                    }
                }
            ]
        });
        document.head.appendChild(script);

    },

    beforeDestroy() {
        if (this.statsObserver) {
            this.statsObserver.disconnect();
        }
        window.removeEventListener('click', this.handleOutsideClick);
    },
};
